module.exports = __webpack_public_path__ + "img/icon-heart.c5dd14de.svg";